import { CommonModule, NgClass } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { UserService } from '@app/services/user-roles.service';
import { IonIcon, IonSpinner } from '@ionic/angular';
import { addIcons } from 'ionicons';
import { chevronForwardSharp } from 'ionicons/icons';
import { map, Observable, Subscription } from 'rxjs';
import { ToasterService } from '@app/services/toaster.service';
import { CoreApiService } from '@app/services/core-api.service';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-left-side-bar',
  templateUrl: './left-side-bar.component.html',
  styleUrls: ['./left-side-bar.component.css'],
  standalone: true,
  imports: [CommonModule, NgClass, IonIcon, IonSpinner],
})
export class LeftSideBarComponent implements OnInit, OnDestroy {
  @ViewChildren('listItem') listItems!: QueryList<ElementRef>;

  isExpanded: boolean;
  isHistoryActive: boolean;
  isCurrentActive: boolean;
  highlighterPos: number;
  selectedPageHref: string;
  path: any;
  activeMenuHref: string = '/';
  isManualDownloading = false;
  private urlSubscription: Subscription = new Subscription();
  private observer!: IntersectionObserver;

  constructor(
    private router: Router,
    private userService: UserService,
    private coreApiService: CoreApiService,
    private toasterService: ToasterService,
  ) {
    addIcons({ chevronForwardSharp });

    this.isExpanded = false;
    this.isHistoryActive = false;
    this.isCurrentActive = false;
    this.highlighterPos = 8;
    this.selectedPageHref = '/';
  }

  private getBaseMenuHref(url: string): string {
    const [pathOnly] = url.split('?');
    const [cleanPath] = pathOnly.split('#');
    const firstSegment = cleanPath.split('/')[1];
    return firstSegment ? `/${firstSegment}` : '/';
  }

  ngOnInit(): void {
    this.urlSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.selectedPageHref = event.url;
        this.activeMenuHref = this.getBaseMenuHref(event.url); // update active menu on navigation
        const foundElement = this.listItems.find((item) => {
          const firstSegment = this.getBaseMenuHref(this.selectedPageHref);
          return firstSegment === item.nativeElement.getAttribute('data-href');
        });
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            setTimeout(() => {
              this.highlighterPos = foundElement!.nativeElement.offsetTop || this.highlighterPos;
            }, 1000);
          });
        });
        if (foundElement) {
          this.observer.observe(foundElement.nativeElement);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.urlSubscription.unsubscribe();
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  async toggleSidebar() {
    this.isExpanded = !this.isExpanded;
  }

  getIsHomePage(href: string) {
    return this.activeMenuHref === href;
  }

  showMenuItem(role: string): Observable<boolean> {
    return this.userService.getRoles().pipe(map((roles) => roles.includes(role)));
  }

  showMenu(): Observable<boolean> {
    return this.userService.getRoles().pipe(
      map((roles) => {
        return true;
        //!!roles?.length
      }),
    );
  }

  onMenuItemClick(event: MouseEvent) {
    event.preventDefault();
    const element = event.currentTarget as HTMLDivElement;
    const dataHref = element.getAttribute('data-href');
    if (dataHref) {
      this.selectedPageHref = dataHref;
      this.activeMenuHref = dataHref; // set active menu
      this.router.navigateByUrl(dataHref);
      this.highlighterPos = element.offsetTop || this.highlighterPos;
    }
  }

  // downloadManual() {
  //   if (this.isManualDownloading) {
  //     return;
  //   }

  //   this.isManualDownloading = true;

  //   this.coreApiService.downloadBumpUpManual().subscribe({
  //     next: (response: HttpResponse<Blob>) => {
  //       const blob = response.body;

  //       if (!blob) {
  //         this.isManualDownloading = false;
  //         this.toasterService.error({ message: 'Failed to download user manual. Please try again.' });
  //         return;
  //       }

  //       const contentDisposition = response.headers.get('content-disposition') || '';
  //       const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
  //       const downloadFileName = decodeURIComponent(
  //         fileNameMatch?.[1] || fileNameMatch?.[2] || 'Cockpit-User-Manual.pptx',
  //       );
  //       const url = URL.createObjectURL(blob);

  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.download = downloadFileName;
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       URL.revokeObjectURL(url);

  //       this.isManualDownloading = false;
  //     },
  //     error: () => {
  //       this.isManualDownloading = false;
  //       this.toasterService.error({ message: 'Failed to download user manual. Please try again.' });
  //     },
  //   });
  // }
  async downloadManualAssets() {
    if (this.isManualDownloading) return;

    this.isManualDownloading = true;

    // 1. Update the path to the .pdf file
    const fileUrl = 'assets/ordersmart-cockpit-user-manual.pdf';
    const fileName = 'ordersmart-cockpit-user-manual.pdf';

    try {
      const response = await fetch(fileUrl);

      if (!response.ok) throw new Error('File download failed');

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading the PDF:', error);
    } finally {
      this.isManualDownloading = false;
    }
  }
}
